import React, { useState } from "react";

import { Arrow } from "../../svg/Svgs";

import "./Slider.scss";
const Slider = (props) => {
  const { images } = props;
  const [counter, setCounter] = useState(0);

  const incrementCounter = () => {
    setCounter((count) => count + 1);
  };
  const decrementCounter = () => {
    setCounter((count) => count - 1);
  };

  const imagesBlock = images.map((data, idx) => (
    <img
      key={idx}
      onClick={props.onClick}
      className={`project-img ${counter === idx ? "project-img--shown" : ""}`}
      src={images[idx]}
      alt="project"
    ></img>
  ));
  return (
    <div className="card">
      <div className="controls">
        <button
          className={`left-btn ${counter === 0 ? "left-btn--hidden" : ""}`}
          onClick={decrementCounter}
        >
          <Arrow styleName="arrow arrow--left" fill="#fff"></Arrow>
        </button>
        <button
          className={`right-btn ${
            images.length - 1 === counter ? "right-btn--hidden" : ""
          }`}
          onClick={incrementCounter}
        >
          <Arrow styleName="arrow" fill="#fff"></Arrow>
        </button>
      </div>
      {imagesBlock}

      {props.children}
    </div>
  );
};

export default Slider;
